import React from 'react';
import Modal from 'react-modal';
import Row from '../tag/Row';
import OTButton from '../tag/OTButton';
import modal from '../../definitions/Modal';
import { FormattedMessage, injectIntl } from "react-intl";

const {id: module_id} = module;

const formSubmitModal = modal({
   content: { width: '320px', padding: '30px'}
});

const FormSubmitModal = (props) => {
    let {
        intl,
        isOpen,
        confirmRedirect,
        moduleId = module_id
    } = props;

    return (
        <Modal
            isOpen={isOpen}
            shouldReturnFocusAfterClose={false}
            shouldFocusAfterRender
            shouldCloseOnEsc={false}
            shouldCloseOnOverlayClick={false}
            style={formSubmitModal}
            contentLabel={intl.formatMessage({id:`${module_id}.contentLabel`})}
        >
            <div className="formula-submit-modal-content">
                <Row className="formula-submit-modal-content-row">
                    <span>
                    <FormattedMessage id={`${module_id}.content`} />
                </span>
                </Row>
                <Row className="formula-submit-modal-content-row">
                    <OTButton
                        message={intl.formatMessage({id: `${module_id}.redirect`})}
                        onClick={() => confirmRedirect()} />
                </Row>
            </div>
        </Modal>
    )

}

export default injectIntl(FormSubmitModal);